import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=4db4f2e1&scoped=true"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"
import style0 from "./additional.vue?vue&type=style&index=0&id=4db4f2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4f2e1",
  null
  
)

export default component.exports